(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    // Loop "Bundle Subscription" plan IDs — shared across all products
    // and never change. Strip these from dropdowns so only brand-specific
    // selling plans (NP-FRENCH-V2, NP-HYDRO-V2, NP-ORO when launched) show.
    var BUNDLE_PLAN_IDS = ['4973494383', '4973527151'];

    function cleanFeaturedCards() {
      var sections = document.querySelectorAll('.np-featured');
      sections.forEach(function (section) {
        var idsAttr = section.getAttribute('data-bundle-plan-ids') || '';
        var bundleIds = idsAttr.split(',').map(function (id) {
          return id.trim();
        }).filter(Boolean);
        if (bundleIds.length === 0) bundleIds = BUNDLE_PLAN_IDS;

        var cards = section.querySelectorAll('.np-card');
        cards.forEach(function (card) {
          if (card.dataset.npBundleCleaned === 'true') return;

          var select = card.querySelector('[data-freq-select]');
          if (!select) {
            card.dataset.npBundleCleaned = 'true';
            return;
          }

          // Track whether the currently selected option is about to be removed
          var currentValue = select.value;
          var currentWasBundle = bundleIds.indexOf(currentValue) !== -1;

          // Remove bundle plan options
          bundleIds.forEach(function (id) {
            var opt = select.querySelector('option[value="' + id + '"]');
            if (opt) opt.remove();
          });

          // If the selected option was a bundle plan (or got removed), pick
          // the first remaining option and re-sync the displayed price.
          if (currentWasBundle && select.options.length > 0) {
            select.selectedIndex = 0;
            select.dispatchEvent(new Event('change', { bubbles: true }));

            // Also update the form's data-selling-plan-id attribute
            var form = card.querySelector('[data-product-form]');
            var subRadio = card.querySelector('.np-card__plan-radio[data-plan-type="subscription"]');
            var newPlanId = select.value;
            if (form && newPlanId) {
              form.setAttribute('data-selling-plan-id', newPlanId);
              form.dataset.sellingPlanId = newPlanId;
            }
            if (subRadio && newPlanId) {
              subRadio.setAttribute('data-plan-id', newPlanId);
            }

            // Sync the visible subscription price from the new option
            var opt = select.options[select.selectedIndex];
            if (opt) {
              var priceEl = card.querySelector('[data-sub-price-display]');
              var savePctEl = card.querySelector('[data-save-pct]');
              if (priceEl && opt.dataset.planPrice) priceEl.textContent = opt.dataset.planPrice;
              if (savePctEl && opt.dataset.planSavingsPct) savePctEl.textContent = opt.dataset.planSavingsPct;
            }
          }

          card.dataset.npBundleCleaned = 'true';
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cleanFeaturedCards);
    } else {
      cleanFeaturedCards();
    }

    // Re-run when sections re-render (e.g., theme editor preview, cart updates
    // that re-render the featured grid, etc.)
    document.addEventListener('shopify:section:load', cleanFeaturedCards);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
